import React from 'react';

import { SignupConsumerByPeoPayrollProviderPageForm } from 'src/components/auth/SignupConsumerPageForm/SignupConsumerByPeoPayrollProviderPageForm';
import { PositionDetailsModal } from 'src/modals/position';
import { AuthSignupConsumerPeoPayrollProvider } from 'src/providers/AuthSignupConsumerProvider/AuthSignupConsumerPeoPayrollProvider';

export const SignupConsumerByPeoPayrollProviderPage: React.FC = () => {
  return (
    <AuthSignupConsumerPeoPayrollProvider>
      <SignupConsumerByPeoPayrollProviderPageForm />

      <PositionDetailsModal />
    </AuthSignupConsumerPeoPayrollProvider>
  );
};
